import Eventable from '../toolkit/eventable';
import { closest, findMeta } from '../toolkit/dom';

const PROCESSING_CLASS = 'processing';
const WRAPPER_SELECTOR = '.attachment';
const META_SELECTOR = 'meta[name=\'csrf-token\']';

class UserMessagesInboxFileInput extends Eventable {
  constructor(input, form) {
    super(input, form);

    this.input = input;
    this.form = form;

    let action = this.form.getAttribute('action');
    if (!action) {
      throw new TypeError('Attachment form is missing action attribute');
    }
    this.action = action;
    let meta = findMeta(META_SELECTOR);
    this.csrfToken = meta.getAttribute('content');

    let wrapper = closest(this.input, WRAPPER_SELECTOR);
    if (!(wrapper instanceof HTMLElement)) {
      throw new Error('Unable to locate file input wrapper');
    }
    this.wrapper = wrapper;

    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    this.wrapper.classList.add(PROCESSING_CLASS);

    this.send()
      .then(response => {
        response.attachments.forEach(attachment => {
          this.emit('newfile', attachment);
        });
        this.wrapper.classList.remove(PROCESSING_CLASS);
      })
      .catch(error => {
        this.wrapper.classList.remove(PROCESSING_CLASS);
        alert(error);
      });
  }

  send() {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest();
      request.open('POST', this.action, true);
      request.setRequestHeader('X-CSRF-Token', this.csrfToken);
      request.setRequestHeader('Accept', 'application/json');
      request.responseType = 'json';

      request.onload = () => {
        if (request.status < 200 || request.status >= 400) {
          reject('Unable to send attachment');
          return;
        }
        resolve(request.response);
      };

      request.onerror = () => {
        reject('Unable to reach server to send attachment');
      };

      request.send(new FormData(this.form));
    });
  }

  empty() {
    this.input.value = '';
  }
}

export default UserMessagesInboxFileInput;



// WEBPACK FOOTER //
// ./src/javascripts/user_messages/user_messages_inbox_file_input.js